import React from 'react';
import { ENV } from 'config/config';
import { Button, Form, Container, Row, Col, OverlayTrigger, Modal, FormGroup } from "react-bootstrap";
const { formatUrl, formatMetaKeywords, integerNumberValidator } = ENV

const GalleryModal = ({ modalCloseHandler, setImage, openModal, submit, galleryErrors, setGalleryErrors }) => {

    const onFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const acceptedExtensions = ['.jpg', '.jpeg', '.png',];
            const fileExtension = '.' + file.name.split('.').pop().toLowerCase();
            if (!acceptedExtensions.includes(fileExtension)) {
                setGalleryErrors('Invalid file extension.\nValid file extentions are: jpg, jpeg and png');
                e.target.value = null; // Deselect the file
                setImage(null); // Clear the image state
            } else {
                setImage(file); // Update the image state with the selected file
            }
        }
    };

    return (
        <Container fluid>
            {
                openModal &&
                <Modal className="modal-primary edit-cotnact-modal" onHide={modalCloseHandler} show={openModal}>
                    <Modal.Header className="justify-content-center">
                        <Row>
                            <div className="col-12">
                                <h4 className="mb-0 mb-md-3 mt-0">
                                    Add Image
                                </h4>
                            </div>
                        </Row>
                    </Modal.Header>
                    <Modal.Body>
                        <Form className="text-left">
                            <Form.Group>
                                <label className=''>Image <span className="text-danger">*</span> </label>
                                <Form.Control
                                    className=""
                                    placeholder="Image"
                                    type="file"
                                    varient="info"
                                    accept=".jpg,.jpeg,.png"
                                    onChange={(e) => onFileChange(e)}
                                    id="image"
                                />
                                <span className={galleryErrors !== '' ? `` : `d-none`}>
                                    <label className="pl-1 text-danger">{galleryErrors}</label>
                                </span>

                            </Form.Group>

                        </Form>
                    </Modal.Body>

                    <Modal.Footer>
                        <Button className="outline-button" onClick={modalCloseHandler}>Close</Button>
                        <Button className="btn-filled"
                            onClick={submit}
                        >
                            Submit
                        </Button>


                    </Modal.Footer>
                </Modal>
            }
        </Container >
    )
}

export default GalleryModal;